import { ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getJobSwmsEmergencyReadiness = (abortController, swmsId, jobId) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/rescue-readiness-questions`, { ...abortController })
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch((error) => Promise.reject(
      error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : Strings.network_error
    ));
};

const normalizeReadinessResponse = (response, fallback) => {
  const payload = response && typeof response === "object" ? response : {};
  const responseData = payload.data && typeof payload.data === "object" ? payload.data : payload;
  const fallbackDocument = fallback && fallback.document && typeof fallback.document === "object"
    ? fallback.document
    : fallback;
  const readiness = responseData.emergency_readiness || responseData.document
    || (Array.isArray(responseData.questions) || Array.isArray(responseData.data) ? responseData : fallbackDocument);
  const source = readiness && typeof readiness === "object" ? readiness : {};
  const questions = Array.isArray(source.questions)
    ? source.questions
    : (Array.isArray(source.data) ? source.data : (fallbackDocument && fallbackDocument.questions) || []);

  return {
    message: responseData.message || payload.message || "Emergency Readiness saved successfully.",
    emergency_readiness: {
      ...fallbackDocument,
      ...source,
      questions
    },
    version_created: responseData.version_created === true || payload.version_created === true
  };
};

export const normalizeJobSwmsEmergencyReadinessResponse = normalizeReadinessResponse;

export const saveJobSwmsEmergencyReadiness = (jobId, swmsId, readinessPayload) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  const fallback = readinessPayload && typeof readinessPayload === "object"
    ? readinessPayload
    : { version: 1, document: { questions: [] } };

  return scopeApiInstance.put(
    `${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/rescue-readiness-questions`,
    fallback
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(normalizeReadinessResponse(res.data, fallback));
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : Strings.network_error
  ));
};
